import { render, staticRenderFns } from "./SlotClosureAddDialog.vue?vue&type=template&id=228d3398&scoped=true"
import script from "./SlotClosureAddDialog.vue?vue&type=script&lang=js"
export * from "./SlotClosureAddDialog.vue?vue&type=script&lang=js"
import style0 from "./SlotClosureAddDialog.vue?vue&type=style&index=0&id=228d3398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228d3398",
  null
  
)

export default component.exports